import { apiClient } from "@/shared/api/client"

// Dashboard summary from the backend
export interface DashboardSummary {
  totalPonds: number
  activePonds: number
  totalFishStock?: number
  totalWaterVolume?: number
  averageWaterQuality?: number
  lastChecked?: string
  totalWaterTests: number
  totalHealthChecks: number
}

// Full dashboard response from /analytics/user-summary
export interface DashboardResponse {
  farmId: string
  farmName: string
  summary: DashboardSummary
  pondOverview: unknown[]
  alerts: unknown[]
  recentActivity: unknown[]
  upcomingTasks: unknown[]
}

export const analyticsApi = {
  /**
   * Get user analytics summary across all farms
   * Returns dashboard metrics including total ponds, water tests, and health checks
   */
  getUserSummary: async (): Promise<DashboardResponse> => {
    const response = await apiClient.get<{ data: DashboardResponse }>("/analytics/user-summary")
    return response.data.data
  },
}
